import { IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class PermissaoCriarDto {
  @IsString()
  @IsNotEmpty()
  nome: string;

  @IsString()
  @IsOptional()
  descricao?: string;
}
